function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M60 31.8c0 15.4-12.6 28-28 28s-28-12.6-28-28 12.6-28 28-28 28 12.6 28 28z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.6 35.8v13.8c0 2.4-2 4.6-4.6 4.6h-2.2c-2.4 0-4.6-2-4.6-4.6v-13.8",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 23.4c0 7.8-6.2 14-14 14s-14-6.2-14-14 6.2-14 14-14 14 6.2 14 14z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 14.4v4l2.8 2.8-2.8 2.8v8.4",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));

var SvgCylinder = function SvgCylinder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCylinder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cylinder.97cadcca.svg";
export { ForwardRef as ReactComponent };